

















import Vue from 'vue'
import paneContent from './components/paneContent.vue'

export default Vue.extend({
  name: '',
  components: {
    paneContent
  },
  data() {
    return {
      tabs: ['page_quality_station', 'page_bill_classify_plan'],
      currentTab: 1
    }
  },
  methods: {}
})
